/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon16Solid = forwardRef('ArrowDCornerRightDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7 3.25a.75.75 0 0 1 .75.75v7.232L5.384 8.866a1.25 1.25 0 1 0-1.768 1.768l3.652 3.651a2.45 2.45 0 0 0 3.464 0l3.652-3.651a1.25 1.25 0 0 0-1.768-1.768l-2.366 2.366V4A3.25 3.25 0 0 0 7 .75H1.25a1.25 1.25 0 1 0 0 2.5H7Z" })));
});
